import { ACCEL_NEUTRAL, accelLevelColor, ACCEL_LEVELS, type AccelScale } from '../analysis/accel'
import { EVENT_COLORS, EVENT_LABELS, type AccelEventKind } from '../analysis/accelEvents'
import type { AccelMode } from '../lib/persist'

const KEY_ORDER: AccelEventKind[] = ['brake', 'neutral', 'drive']
const KEY_TEXT: Record<AccelEventKind, string> = { brake: 'brake', neutral: 'hold speed', drive: 'drive' }

/**
 * The key to the acceleration on the racing lines. Lanes: the colour strip, braking (red) …
 * coasting … driving (green). Points: the three dots and what each marks.
 */
export default function AccelLegend({ scale, mode = 'lanes' }: { scale: AccelScale; mode?: AccelMode }) {
  if (mode === 'points')
    return (
      <div className="accel-legend points" title="Dots on the racing lines: where braking starts, where it ends and the throttle holds the speed, where the drive starts">
        {KEY_ORDER.map((k) => (
          <span key={k} className="accel-key" title={EVENT_LABELS[k]}>
            <span className="dot" style={{ background: EVENT_COLORS[k] }} />
            {KEY_TEXT[k]}
          </span>
        ))}
      </div>
    )
  const gradient = `linear-gradient(to right, ${accelLevelColor(-ACCEL_LEVELS)}, ${ACCEL_NEUTRAL} 50%, ${accelLevelColor(ACCEL_LEVELS)})`
  return (
    <div className="accel-legend" title="Colour along the racing lines: red braking, green accelerating">
      <span>−{scale.maxBrake.toFixed(1)} g</span>
      <span className="accel-bar" style={{ background: gradient }} />
      <span>+{scale.maxAccel.toFixed(1)} g</span>
    </div>
  )
}
